<template>
  <div>
    <div id="platmap-modal" class="embinfobox basic">
      <div v-bind:class="['map-card']">
        <i aria-label="close icon" class="emb_closeicon"></i>
        <div
          v-if="!lodash.isEmpty(lotInfo)"
          class="map-card-body"
          :class="lotStatus"
        >
          <div class="flexCol mb-4" :class="lotStatus">
            <div class="flexRow items-end lot-top-block">
              <h3 class="lotid-title">Site {{ lotId }}</h3>
              <span
                class="lotinfo-colors"
                v-bind:style="{ color: lotInfo.lot.color }"
              >
              <SoldPendingStatus
                v-if="lotInfo.lot.status === 'Sold Pending'"
                svgClass="dsize"
              />

              <SoldContingencyStatus
                v-else-if="lotInfo.lot.status === 'Sold Contingency'"
                svgClass="dsize"
              />
                <i
                v-else
                  v-bind:style="{ backgroundColor: lotInfo.lot.color }"
                  class="dsize"
                ></i>
                {{ lotInfo.lot.status === 'QMI' ? 'Quick Move-In' : lotInfo.lot.status }}
              </span>
            </div>
            <div class="location-block" v-if="lotInfo.lot.address">
              <span class="location-block-title wo-line">
                {{ lotInfo.lot.address }}
              </span>
              <i class="location-block-icon">
                <Location />
              </i>
              <span class="location-block-title font-semibold">
                {{ lotInfo.neighborhoodName }}
              </span>
            </div>
            <h4
              class="lotinfo-mktitle"
              v-if="
                lotInfo.lot.marketing_headline &&
                ![availableStatus.SOLD, availableStatus.RESERVED].includes(
                  lotInfo.lot.status
                )
              "
            >
              {{ lotInfo.lot.marketing_headline }}
            </h4>
          </div>

          <div
            class="tabs"
            style="margin-bottom: 6px"
            v-if="
              [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
                lotInfo.lot.status
              )
            "
          >
            <input
              type="radio"
              name="tabs"
              id="tabone"
              checked
              v-show="lotInfo.homes_plans.length"
            />
            <label for="tabone" v-show="showHomePlanLabel">
              <span v-if="!showFutureHomePlanLabel">
                {{
                  `${lotInfo.homes_plans.length || 0} home plans available`
                }}</span
              >
              <span v-else>Home Plans</span>
            </label>
            <div class="tab" v-if="lotInfo.homes_plans.length">
              <div
                v-if="!!lotInfo.homes_plans.length"
                class="tab-slider"
                v-bind:style="{ display: loading ? 'none' : '' }"
              >
                <Carousel
                  v-bind="carouselConfig"
                  v-if="!!lotInfo.homes_plans.length"
                >
                  <Slide
                    v-for="homePlan in lotInfo.homes_plans"
                    :key="homePlan.id"
                  >
                    <div v-if="!!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource(homePlan.image_url[0])"
                        :alt="
                          !!homePlan.image_url.length
                            ? homePlan.image_url[0].caption
                            : homePlan.name
                        "
                        :isNeighborhoodImage="false"
                        :showDefaultImage="showDefaultImage"
                      />
                    </div>
                    <div v-if="!!!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource('')"
                        :alt="homePlan.name"
                        :isNeighborhoodImage="false"
                        :showDefaultImage="showDefaultImage"
                      />
                    </div>

                    <div class="flexDiv mb-5 mt-5">
                      <h2
                        class="homePlan-name"
                        @click="
                          !isKioskMode
                            ? openPlanDetails(homePlan.plan_url)
                            : openKioskPlanView(homePlan.id)
                        "
                        style="cursor: pointer"
                      >
                        {{ homePlan.name }}
                        <span
                          v-if="
                            [availableStatus.FUTURE_HOME].includes(
                              lotInfo.lot.status
                            )
                          "
                        >
                          &nbsp;{{ homePlan.elevation }}
                        </span>
                      </h2>
                      <div class="price-block">
                        <span class="price-block-panel-text" v-if="!!homePlan.price_high &&
                        ![availableStatus.FUTURE_HOME].includes(lotInfo.lot.status)">Starts at</span>
                        <div class="price-block-panel">
                          <span
                            v-if="
                              [availableStatus.AVAILABLE].includes(
                                lotInfo.lot.status
                              ) && homePlan.price_low !== 0
                            "
                            >{{
                              formatPrice(
                                lotInfo.lot.net_premium + homePlan.price_low
                              )
                            }}</span
                          >
                          <!-- <span
                            v-if="checkRangeAndFutureHome(homePlan)"
                            >-</span
                          >
                          <span v-if="checkRangeAndFutureHome(homePlan)">{{
                            formatPrice(
                              lotInfo.lot.net_premium + homePlan.price_high
                            )
                          }}</span> -->
                        </div>
                      </div>
                    </div>

                    <p class="amenities-list mb-8">
                      <span v-if="!!homePlan.sqft_low || !!homePlan.sqft_high">
                        <span
                          v-if="
                            checkLowRange('sqft_low', 'sqft_high', homePlan)
                          "
                          >{{ formatSquareFeet(homePlan.sqft_low) }}</span
                        >
                        <span
                          v-if="isRange(homePlan.sqft_low, homePlan.sqft_high)"
                          >-</span
                        >
                        <span v-if="!!homePlan.sqft_high">{{
                          formatSquareFeet(homePlan.sqft_high)
                        }}</span>
                        sq. ft. |
                      </span>
                      <span
                        v-if="!!homePlan.stories_low || !!homePlan.stories_high"
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'stories_low',
                              'stories_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.stories_low }}</span
                        >
                        <span
                          v-if="
                            isRange(homePlan.stories_low, homePlan.stories_high)
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.stories_high">{{
                          homePlan.stories_high
                        }}</span>
                        story |
                      </span>
                      <span
                        v-if="
                          !!homePlan.bedrooms_low || !!homePlan.bedrooms_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'bedrooms_low',
                              'bedrooms_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.bedrooms_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.bedrooms_low,
                              homePlan.bedrooms_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.bedrooms_high">{{
                          homePlan.bedrooms_high
                        }}</span>
                        bed |
                      </span>
                      <span
                        v-if="
                          !!homePlan.fullbaths_low || !!homePlan.fullbaths_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'fullbaths_low',
                              'fullbaths_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.fullbaths_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.fullbaths_low,
                              homePlan.fullbaths_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.fullbaths_high">{{
                          homePlan.fullbaths_high
                        }}</span>
                        full baths |
                      </span>
                      <span
                        v-if="
                          !!homePlan.halfbaths_low || !!homePlan.halfbaths_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRangeHalfBath(
                              'halfbaths_low',
                              'halfbaths_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.halfbaths_low }}</span
                        >
                        <span
                          v-if="
                            isRangeHalfBath(
                              homePlan.halfbaths_low,
                              homePlan.halfbaths_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.halfbaths_high">{{
                          homePlan.halfbaths_high
                        }}</span>
                        half baths |
                      </span>
                      <span
                        v-if="
                          !!homePlan.garagebays_low ||
                          !!homePlan.garagebays_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'garagebays_low',
                              'garagebays_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.garagebays_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.garagebays_low,
                              homePlan.garagebays_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.garagebays_high">{{
                          homePlan.garagebays_high
                        }}</span>
                        car garage
                      </span>
                    </p>
                  </Slide>
                  <template #addons>
                  <div class="carousel-navigation">
                      <Navigation />
                    </div>
                  </template>
                </Carousel>
              </div>
            </div>

            <!--tab2-->
            <input
              type="radio"
              name="tabs"
              id="tabtwo"
              v-show="!!lotInfo.lot.images.length"
              @click="handleSiteReInit()"
            />
            <label for="tabtwo" v-show="!!lotInfo.lot.images.length"
              >Site photos</label
            >
            <div class="tab site-photo" v-show="!!lotInfo.lot.images.length">
              <div class="tab-slider relative">
                <Carousel
                  v-bind="carouselConfig"
                  v-show="!!lotInfo.lot.images.length"
                >
                  <Slide
                    v-for="image in lotInfo.lot.images"
                    :key="image.seq_position"
                  >
                    <LazyImage
                      :src="imageSource(image)"
                      :alt="image.caption"
                      :isNeighborhoodImage="false"
                    />
                    <p class="slider-caption" v-if="!!image.caption">
                      {{ image.caption }}
                    </p>
                  </Slide>
                  <template #addons>
                    <div class="carousel-navigation">
                      <Navigation />
                    </div>
                  </template>
                </Carousel>
              </div>
              <div class="flexDiv">
                <h2 class="homePlan-name green">
                  {{ messages.sitePhotosH3Message }}
                </h2>
              </div>
              <p class="amenities-list">{{ messages.sitePhotosPMessage }}</p>
            </div>
          </div>
          <template
            v-else-if="
              [availableStatus.QUICK_MOVE_IN, availableStatus.MODEL].includes(
                lotInfo.lot.status
              )
            "
          >
            <span
              class="location-block-date"
              v-if="lotInfo.homes_plans[0].move_in_date"
              >Move-in date:
              {{
                new Date() >= new Date(lotInfo.homes_plans[0].move_in_date)
                  ? "Immediate"
                  : formatDate(lotInfo.homes_plans[0].move_in_date)
              }}</span
            >
            <div :class="{ tabs: lotStatus == 'qmi' }">
              <input
                type="radio"
                name="tabs"
                id="tabone"
                checked
                v-show="lotStatus == 'qmi' && lotInfo.homes_plans.length"
              />
              <label
                for="tabone"
                v-show="lotStatus == 'qmi' && lotInfo.homes_plans.length"
                >Home Plans</label
              >
              <div
                class="tab"
                v-for="homePlan in lotInfo.homes_plans"
                :key="homePlan.id"
              >
                <div
                  class="flexDiv"
                  v-if="lotInfo.lot.status !== 'Quick Move-In'"
                >
                  <h2
                    class="homePlan-name"
                    v-on="
                      !isKioskMode && homePlan.plan_url
                        ? { click: () => openPlanDetails(homePlan.plan_url) }
                        : undefined
                    "
                    :style="[
                      !isKioskMode
                        ? { cursor: 'pointer' }
                        : { pointerEvents: 'none', textDecoration: 'none' },
                    ]"
                  >
                    <span>{{ convertToTitleCase(homePlan.name) }}</span>
                    <span v-if="homePlan.elevation">{{
                      homePlan.elevation
                    }}</span>
                  </h2>
                </div>
                <div class="tab-slider">
                  <Carousel v-bind="carouselConfig">
                    <Slide
                      v-for="homePlanImage in homePlan.image_url"
                      :key="homePlanImage.seq_position"
                      class="tab-slider"
                    >
                      <LazyImage
                        :src="imageSource(homePlanImage)"
                        :alt="homePlanImage.caption"
                        :isNeighborhoodImage="false"
                      />
                      <p class="slider-caption" v-if="!!homePlanImage.title">
                        {{ homePlanImage.title }}
                      </p>
                    </Slide>
                    <template #addons>
                      <div class="carousel-navigation">
                        <Navigation />
                      </div>
                    </template>
                    <div v-if="!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource('')"
                        :alt="''"
                        :isNeighborhoodImage="false"
                      />
                    </div>
                  </Carousel>
                </div>
                <div
                  class="flexDiv mb-5"
                  v-if="lotInfo.lot.status === 'Quick Move-In'"
                >
                  <h2
                    class="homePlan-name"
                    @click="
                      !isKioskMode
                        ? openPlanDetails(homePlan.plan_url)
                        : openKioskPlanView(homePlan.id)
                    "
                    style="cursor: pointer"
                  >
                    <span>{{ homePlan.name }}</span>
                    <span v-if="homePlan.elevation">
                      &nbsp;{{ homePlan.elevation }}</span
                    >
                  </h2>
                  <div class="price-block">
                    <span
                      class="price-block-panel"
                      v-if="!!homePlan.price_high"
                    >
                      <span class="understrike" v-if="!!homePlan.wasprice">
                        {{ formatPrice(homePlan.wasprice) }}
                      </span>
                      {{ formatPrice(homePlan.price_high) }}
                    </span>
                  </div>
                </div>
                <div class="amenities-list mb-8">
                  <span
                    class="under-construction-list"
                    v-if="
                      lotInfo.lot.status == 'Quick Move-In' &&
                      !!homePlan.target_date
                    "
                  >
                    {{ homePlan.target_date }}
                  </span>
                  <span v-if="!!homePlan.sqft_high">
                    Square Ft:
                    <span class="nbsp"></span>
                    {{ formatSquareFeet(homePlan.sqft_high) }} |
                  </span>
                  <span v-if="!!homePlan.stories_high">
                    Story:
                    <span class="nbsp"></span>
                    {{ homePlan.stories_high }} |
                  </span>
                  <span v-if="!!homePlan.bedrooms_high">
                    Bedrooms:
                    <span class="nbsp"></span>
                    {{ homePlan.bedrooms_high }} |
                  </span>
                  <span v-if="!!homePlan.fullbaths_high">
                    Full Baths:
                    <span class="nbsp"></span>
                    {{ homePlan.fullbaths_high }} |
                  </span>
                  <span v-if="!!homePlan.halfbaths_high">
                    Half Baths:
                    <span class="nbsp"></span>
                    {{ homePlan.halfbaths_high }} |
                  </span>
                  <span v-if="!!homePlan.garagebays_high">
                    Garage:
                    <span class="nbsp"></span>
                    {{ homePlan.garagebays_high }}-car
                  </span>
                </div>
              </div>

              <!--tab2-->
              <input
                type="radio"
                name="tabs"
                id="tabtwo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
                @click="handleSiteReInit()"
              />
              <label
                for="tabtwo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
                >Site photos</label
              >
              <div
                class="tab site-photo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
              >
                <div class="tab-slider relative">
                  <Carousel
                    v-bind="carouselConfig"
                    v-show="!!lotInfo.lot.images.length"
                  >
                    <Slide
                      v-for="image in lotInfo.lot.images"
                      :key="image.seq_position"
                    >
                      <LazyImage
                        :src="imageSource(image)"
                        :alt="image.caption"
                        :isNeighborhoodImage="false"
                      />
                      <p class="slider-caption" v-if="!!image.caption">
                        {{ image.caption }}
                      </p>
                    </Slide>
                    <template #addons>
                      <div class="carousel-navigation">
                        <Navigation />
                      </div>
                    </template>
                  </Carousel>
                </div>
                <div class="flexDiv">
                  <h3 class="homePlan-name green">
                    {{ messages.sitePhotosH3Message }}
                  </h3>
                </div>
                <p class="amenities-list">{{ messages.sitePhotosPMessage }}</p>
              </div>
            </div>
          </template>
          <div v-else-if="[availableStatus.SOLD].includes(lotInfo.lot.status)">
            <div v-if="!!lotInfo.homes_plans.length">
              <div class="sold">
                <h2 class="homePlan-name mb-8">
                  <span>{{ lotInfo.homes_plans[0].name }}</span>
                  <span v-if="!!lotInfo.homes_plans[0].elevation">
                    &nbsp;{{ lotInfo.homes_plans[0].elevation }}</span
                  >
                </h2>
              </div>
              <div
                class="tab"
                v-if="
                  !!lotInfo.homes_plans[0].image_url.length &&
                  !!lotInfo.homes_plans[0].image_url[0].image_url
                "
              >
                <div class="tab-slider">
                  <LazyImage
                    :src="imageSource(lotInfo.homes_plans[0].image_url[0])"
                    :alt="lotInfo.homes_plans[0].image_url[0].caption"
                    :isNeighborhoodImage="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="showSoldMessage && !isSalesOrLandView" class="soldHomes-msg">
            {{ trailingText[0] }}
            <span class="linkScheduleVisit" @click="mobileOpenContactInfo()">{{
              linkOpenConatactInfo
            }}</span>
            {{ trailingText[1] }}
          </div>
          <button
            v-if="!suppressScheduleVisit() && !isSalesOrLandView"
            class="btn schedule-visit-btn"
            id="btnScheduleVisit"
            @click="mobileOpenContactInfo()"
          >
            Schedule a Visit
            <!-- <span class="icon icon-right-white-arrow"></span> -->
          </button>
        </div>
        <div v-else>{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, nextTick, toRefs, inject } from "vue";
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import LazyImage from "./../LazyImage.vue";
import Location from "@/assets/icons/Location.vue";
import lodash from "lodash";
import {
  CommunityQmiDetails,
  HomesPlan,
  LotDetail,
  LotInfo,
  PlanNeighborhoodList,
} from "./../../types";
import { Status, Scalers, LinkOpenConatactInfo } from "./../../constant";
import { apiMessages } from "../../api/message-api";
import { addImageScaler, convertToTitleCase, formatPrice } from "@/core";
import { isIE } from "mobile-device-detect";
import SoldPendingStatus from "@/assets/icons/SoldPendingStatus.vue";
import SoldContingencyStatus from "@/assets/icons/SoldContengencyStatus.vue";

const props = defineProps<{
  lotId: string;
  lotInfo: LotInfo;
  isKioskMode: boolean;
  neighborhoodId: string;
  updateLotInfo: (payload: {
    lotInfo: LotInfo | LotDetail;
    lotId: string;
  }) => void;
  mobileOpenContactInfo: () => void;
}>();
const {
  lotId,
  lotInfo,
  isKioskMode,
  neighborhoodId,
  updateLotInfo,
  mobileOpenContactInfo,
} = toRefs(props);
const emit = defineEmits<{
  (e: "openModal", modalName: string): void;
}>();


const carouselConfig = {
  itemsToShow: 1,
  itemsToScroll: 1,
  wrapAround: false,
};
const availableStatus = Status;
const errorMessage = "Information for this lot is not yet available";
const messages = reactive<any>({});
const loading = isIE;
const trailingText = ref<string[]>([]);
const linkOpenConatactInfo = LinkOpenConatactInfo;
const showDefaultImage = ref(false);

const slick = ref();
const siteSlick = ref();

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));


onMounted(() => {
  updateLotInfo.value({ lotInfo: lotInfo.value, lotId: lotId.value });
  loadMessages();
});

const loadMessages = async () => {
  const { messages: msg } = await apiMessages("PlatMapModal");
  Object.assign(messages, msg);
  trailingText.value = msg.soldHomesMessage.split(linkOpenConatactInfo);
};

const handleReInit = () => {
  nextTick(() => {
    slick.value?.reSlick();
  });
};

const handleSiteReInit = () => {
  nextTick(() => {
    siteSlick.value?.reSlick();
  });
};

const checkLowRange = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null &&
      homePlan[property1]) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1])
  );
};
const checkLowRangeHalfBath = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1] != null)
  );
};

const convertToTitleCaseFn = (val: string) => convertToTitleCase(val);
const formatPriceFn = (val: number) => formatPrice(val);
const formatSquareFeet = (x: number) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const formatDate = (moveInDate: string) => {
  let date = new Date(moveInDate);
  let formattedDate = date.toDateString().split(" ");
  return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
};

const isRange = (val_low: any, val_high: any) =>
  val_low != null && val_low != val_high && val_high && val_low;

const isRangeHalfBath = (val_low: any, val_high: any) =>
  val_low != null && val_high != null && val_high != 0 && val_low != val_high;

const suppressScheduleVisit = () =>
  [
    availableStatus.SOLD,
    availableStatus.RESERVED,
    availableStatus.FUTURE_HOME,
  ].includes(lotInfo.value.lot.status) || isKioskMode.value;

const openPlanDetails = (planURL: Location) => {
  window.open(`${planURL}`, `HomePlans_WindowName`);
};

const openKioskPlanView = (planCode: string) => {
  // console.log('PlatMapInfoWindow...');
  // console.log('planCode = ' + planCode);
  // console.log('jobNumber? = ' + lotInfo.value.lot.id);
  // console.log('nbCode?: ' + lotId.value.split("-")[0]);
  // console.log('selectedneighborhoodIds:');
  // console.log(JSON.stringify(neighborhoodId.value));
  console.log('lotInfo = ');
  console.log(JSON.stringify(lotInfo.value) || 'no lotinfo');
  let nbCode = lotInfo.value.lot.id.split("-")[0] || '';
  let pCode = planCode || '';
  let kioskPlanLink = `${process.env.VUE_APP_URL}planView?`;
  if (lotStatus.value === availableStatus.AVAILABLE.toLowerCase()) {
  //  console.log('neighborhoodId:');
  //  console.log(JSON.stringify(neighborhoodId.value));
    kioskPlanLink += `plan_code=${pCode}&neighborhood_code=${nbCode}`;
  } else if (lotStatus.value === "qmi") {
    kioskPlanLink += `job_number=${lotInfo.value.lot.id}&neighborhood_code=${nbCode}`;
  }
  window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
};

const checkRangeAndFutureHome = (homePlan: HomesPlan) =>
  isRange(homePlan.price_low, homePlan.price_high) &&
  lotInfo.value.lot.status !== availableStatus.FUTURE_HOME;

const imageSource = (src: any) => {
  if (typeof src === "object" && src.image_url) {
    return addScaler(src.image_url);
  } else {
    showDefaultImage.value = true;
    return require("@/assets/images/home-not-available.png");
  }
};

const addScaler = (url: string) => addImageScaler(url);

const showHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans.length &&
    [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    )
);

const showFutureHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans.length &&
    [availableStatus.FUTURE_HOME].includes(lotInfo.value.lot.status)
);

const showSoldMessage = computed(
  () =>
    [availableStatus.SOLD, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) || isKioskMode.value
);

const lotStatus = computed(() => {
  let status = lotInfo.value.lot.status;
  if ([availableStatus.QUICK_MOVE_IN].includes(status)) status = "qmi";
  else if ([availableStatus.SOLD, availableStatus.AVAILABLE].includes(status))
    status = status.toLowerCase();
  return status;
});
</script>

<style lang="scss" scoped>
.linkScheduleVisit {
  text-decoration: underline;
  color: $lime-green-new;
}

.tabs {
  margin-bottom: 6px;
}
</style>
